import HeaderBannerStyled from './HeaderBannerStyled';
import { FrontierLogo } from '../../Icons/outline';
import React, { useState, FC } from 'react';
import setHtml from '~/helpers/setHtml';
import { ArrowRight, Plus } from '../../Icons/fill';
import { useSelector } from 'react-redux';
import { ReduxState } from '~/types/redux';
import { NETFLIX_BUNDLE } from '~/constants/entityIds';
import getAsset from '~/helpers/getAsset';
import { Product } from '~/types/products';
import { trackEvent } from '~/helpers/tracking';

interface Props {
  metadata?: {
    icon: string;
    text: string;
    subText: string;
    backgroundColor: string;
    button?: {
      text: string;
    };
  };
  setClickToToggleNetflixBundle?: (value: boolean) => void;
  setVasModal: (product: Product) => void;
}

const HeaderBanner: FC<Props> = ({
  metadata: { text, icon, subText, backgroundColor, button },
  setVasModal,
  setClickToToggleNetflixBundle,
}) => {
  const { products } = useSelector((store: ReduxState) => store);
  const [baseUrl] = useState('/');
  const isNetflixBanner = icon.includes('netflix');
  const netflixWifiBundle = products?.available?.video?.find((product) => product.productId === NETFLIX_BUNDLE);

  const handleShopBundlePlansClick = () => {
    // If user clicks on the Shop bundle plans CTA, set the clickToToggleNetflixBundle to true and scroll down to the plan packages cards
    setClickToToggleNetflixBundle(true);
    const element = document.querySelector('[data-testid="plan-packages-cards"]');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    trackEvent({
      action: 'elementClicked',
      data: {
        elementType: 'BUTTON',
        position: `${icon} Header Banner`,
        location: 'Header Banner',
        text: button?.text,
      },
    });
  };

  return (
    <HeaderBannerStyled data-testid="header-banner" backgroundColor={backgroundColor}>
      <div className="header-banner__icon-wrapper">
        <a href={baseUrl} aria-label="Home">
          <FrontierLogo width="36" height="36" />
        </a>
        {isNetflixBanner && (
          <>
            <Plus className="header-banner__icon-plus" />
            <img
              className="header-banner__icon-netflix"
              src={getAsset(`/images/logos/netflix-logo.svg`)}
              alt="NetFlix Logo"
            />
          </>
        )}
      </div>
      <div className="header-banner__text-block" data-testid="banner-text">
        <span {...setHtml(text)} />
        {isNetflixBanner && (
          <button className="header-banner__modal" onClick={() => setVasModal(netflixWifiBundle)}>
            {subText}
          </button>
        )}
      </div>
      {isNetflixBanner && (
        <button className="header-banner__toggle-cta" onClick={handleShopBundlePlansClick}>
          {button?.text} <ArrowRight className="header-banner__arrow-down" />
        </button>
      )}
    </HeaderBannerStyled>
  );
};

HeaderBanner.displayName = 'HeaderBanner';

export default HeaderBanner;
